<template>
  <div class="history-result-wrap">
    <div class="springBanner">
      <header-banner :bannerUrl="homeConfig.homepageHeaderImage"/>
    </div>
    <div class="result-module">
      <div class="main-module">
        <div v-if="teamInfo.teamId > 0" class="module-header">
          <titleBar :homeConfig="homeConfig" title="战队赛程" />
        </div>
        <div class="module-content">
          <router-link
            v-if="teamInfo.teamId > 0"
            class="view-all-games"
            :to="`/winterGame/moreSchedule?isHistory=1&scheduleId=${this.scheduleId}&seasonId=${this.seasonId}`"
          >
            <btn title="查看全部赛程"></btn
          ></router-link>
        </div>
      </div>
      <section>
        <header>
          <titleBar :homeConfig="homeConfig" title="战队战绩" />
        </header>
        <footer>
          <normalModule v-if="teamRecordData" :title="teamRecordTitle">
            <ul slot="main" class="rank-data">
              <li>
                <p class="data-num">
                  {{ teamRecordData.score | formatNumberFilter }}
                </p>
                <p class="describe">赛季累计奖杯数</p>
              </li>
              <li>
                <p class="data-num">
                  {{ teamRecordData.pk_count | formatNumberFilter }}
                </p>
                <p class="describe">累计PK局数</p>
              </li>
              <li>
                <p class="data-num">
                  {{ Math.round(teamRecordData.pk_rate / 100) }}%
                </p>
                <p class="describe">PK胜率</p>
              </li>
              <li>
                <p class="data-num">
                  {{ teamRecordData.average_score | formatNumberFilter }}
                </p>
                <p class="describe">平均每局奖杯数</p>
              </li>
            </ul>
            <shareBtn slot="footer" @shareClick="lookBattleReportPoster" />
          </normalModule>
        </footer>
      </section>
      <section v-if="honorList.length > 0">
        <header>
          <titleBar :homeConfig="homeConfig" title="战队荣誉" />
        </header>
        <div class="list">
          <div class="item" v-for="(item, index) in honorList" :key="index">
            <honorModule :honorData="item" @shareClick="shareClick" />
          </div>
        </div>
        <footer v-if="honorListLength > 3">
          <router-link
            :to="`/winterGame/moreHonor?isHistory=1&scheduleId=${this.scheduleId}&seasonId=${this.seasonId}`"
            class="more"
            tag="a"
            >查看更多战队荣誉>
          </router-link>
        </footer>
      </section>
    </div>
    <van-popup style="width: 100%" v-model="isShowStarMemberPopUpDialog">
      <battalionPoster
        :posterUrl="starMemberPoster.posterUrl"
        :isShow="starMemberPoster.isShow"
        @OnCancelPoster="handleCancelStarMemberPoster"
      >
        <div id="starMemberPosterContainer">
          <star-member
            :isMVP="true"
            :teamInfo="teamInfo"
            :posterData="starMemberPosterData"
            v-if="starMemberPoster.isPoster == 1"
          ></star-member>
        </div>
      </battalionPoster>
    </van-popup>
    <van-popup style="width: 100%" v-model="isShowPopUpDialog">
      <battalionPoster
        :posterUrl="teamHonorPoster.posterUrl"
        :isShow="teamHonorPoster.isShow"
        @OnCancelPoster="handleCancelTeamHonorPoster"
      >
        <div id="teamHonorPosterContainer">
          <team-honor
            :teamInfo="teamInfo"
            :posterData="teamHonorPosterData"
            v-if="teamHonorPoster.isPoster == 1"
          ></team-honor>
        </div>
      </battalionPoster>
    </van-popup>
    <van-popup
      style="width: 100%"
      v-model="isShowBattleReportPosterPopUpDialog"
    >
      <battalionPoster
        :posterUrl="battleReportPoster.posterUrl"
        :isShow="battleReportPoster.isShow"
        @OnCancelPoster="handleCancelBattleReportPoster"
      >
        <div id="battleReportPosterContainer">
          <battle-report
            :teamInfo="teamInfo"
            :posterData="battleReportPosterData"
            v-if="battleReportPoster.isPoster == 1"
          >
          </battle-report>
        </div>
      </battalionPoster>
    </van-popup>
  </div>
</template>

<script>
import titleBar from "./components/titleBar.vue";
import shareBtn from "./components/shareBtn.vue";
import normalModule from "./components/normalModule.vue";
import honorModule from "./components/honorModule.vue";
import { eventHomePage, teamRecord, queryseasonpersonalhome } from "@/api/winterGame";
import {
  formatDateStr,
  getHonorDesc,
  getTeamHonorPosterData,
} from "@/util/util";
import { Toast } from "vant";
import battalionPoster from "@components/SquirrelCupII/battalion-poster.vue";
import StarMember from "@views/WinterGame/components/poster/starMember.vue";
import TeamHonor from "@views/WinterGame/components/poster/teamHonor.vue";
import BattleReport from "@views/WinterGame/components/poster/battleReport.vue";
import html2canvas from "html2canvas";
import Btn from "@views/WinterGame/components/btn.vue";
import HeaderBanner from "@views/WinterGame/components/headerBanner.vue";
import { gethonorDescMapConfig } from "@/util/config";
export default {
  components: {
    HeaderBanner,
    Btn,
    BattleReport,
    TeamHonor,
    StarMember,
    battalionPoster,
    titleBar,
    shareBtn,
    normalModule,
    honorModule,
  },
  data() {
    return {
      isShowStarMemberPopUpDialog: false,
      isShowPopUpDialog: false,
      isShowBattleReportPosterPopUpDialog: false,
      starMemberPosterData: null,
      teamHonorPosterData: null,
      battleReportPosterData: null,
      honorList: [],
      honorListLength: 0,
      // 战队荣耀 :1最强战队2连胜战队3最精彩的比赛4满勤战队5最强战队（赛季）6冠军战队7亚军战队8季军战队9战队MVP学员
      honorDescMap: gethonorDescMapConfig(),
      teamRecordData: null, //战队战绩
      currentCampusId: 0,
      currentUserId: 0,
      scheduleId: 0,
      seasonId: 0,
      teamInfo: {
        teamName: "",
        servicePointName: "",
      },
      starMemberPoster: {
        isShow: false,
        isPoster: -1,
        posterUrl: "",
      },
      teamHonorPoster: {
        isShow: false,
        isPoster: -1,
        posterUrl: "",
      },
      battleReportPoster: {
        isShow: false,
        isPoster: -1,
        posterUrl: "",
      },
      homeConfig: {},
    };
  },
  computed: {
    teamRecordTitle() {
      if (this.teamRecordData.sched_rank) {
        return (
          this.teamRecordData.ware_zone +
          "第" +
          this.teamRecordData.sched_rank +
          "名"
        );
      } else {
        return (
          this.teamRecordData.ware_zone +
          "第" +
          this.teamRecordData.ware_zone_rank +
          "名"
        );
      }
    },
  },
  mounted() {
    this.scheduleId = this.$route.query.scheduleId;
    this.seasonId = this.$route.query.seasonId;
    if (this.scheduleId && this.seasonId) {
      this.setUserInfo();
      if (this.currentUserId) {
        this.initTeamInfo();
        this.eventHomePage();
        this.teamRecord();
        this.querySeasonPersonalHome();
      }
    } else {
      Toast("找不到历史赛季信息");
    }
    console.log(this.honorDescMap);
  },
  methods: {
    querySeasonPersonalHome() {
      queryseasonpersonalhome({
        param: {
          seasonTagId: this.seasonId
          // seasonTagId: 's.25.qiuji.1.test'
        }
      }).then(res => {
        if (res.code == 0) {
          this.homeConfig = res.data;
        } else {
          Toast(res.message);
        }
      });
    },
    getWinNum(wining_num) {
      let text = "";
      switch (wining_num) {
        case 3:
          text = "三";
          break;
        case 4:
          text = "四";
          break;
        case 5:
          text = "五";
          break;
        case 6:
          text = "六";
          break;
        case 7:
          text = "七";
          break;
        case 8:
          text = "八";
          break;
        case 9:
          text = "九";
          break;
      }
      return text;
    },
    shareClick(data) {
      // 1最强战队2连胜战队3最精彩的比赛4满勤战队5最强战队（赛季）6冠军战队7亚军战队8季军战队9战队MVP学员10战区单日最强战队
      if (data.type == 9) {
        // 9战队MVP学员
        this.starMemberPosterData = {
          realName: data.honorDesc.userName,
          cupNumber: data.honorDesc.cupNumber,
          date: data.day,
        };
        // 明星学员海报
        this.lookStarMemberPoster();
      } else {
        // 通用海报
        this.teamHonorPosterData = getTeamHonorPosterData(data, this.teamInfo);
        this.lookTeamHonorPoster();
      }
    },
    handleCancelStarMemberPoster(type) {
      this.starMemberPoster.isShow = type;
      this.isShowStarMemberPopUpDialog = false;
    },
    handleCancelTeamHonorPoster(type) {
      this.teamHonorPoster.isShow = type;
      this.isShowPopUpDialog = false;
    },
    handleCancelBattleReportPoster(type) {
      this.battleReportPoster.isShow = type;
      this.isShowBattleReportPosterPopUpDialog = false;
    },
    // 查看团队荣誉海报
    lookTeamHonorPoster() {
      Toast.loading({ message: "加载中...", forbidClick: true, duration: 0 });
      this.teamHonorPoster.isPoster = 1;
      this.isShowPopUpDialog = true;
      setTimeout(() => {
        const targetDom = document.querySelector("#teamHonorPosterContainer");
        // const targetDom = dom.firstChild;
        const config = {
          useCORS: true,
          logging: true,
          width: targetDom.offsetWidth,
          height: targetDom.offsetHeight - 4,
        };
        html2canvas(targetDom, config).then((canvas) => {
          this.teamHonorPoster.isShow = true;
          this.teamHonorPoster.posterUrl = canvas.toDataURL();
          this.teamHonorPoster.isPoster = -1;
          Toast('长按保存图片');;
          // gio("track", "onShareBattleReport", { onSharePosters: "ShareLogo" });
        });
      }, 500);
    },
    lookStarMemberPoster() {
      Toast.loading({ message: "加载中...", forbidClick: true, duration: 0 });
      this.isShowStarMemberPopUpDialog = true;
      this.starMemberPoster.isPoster = 1;

      setTimeout(() => {
        const targetDom = document.querySelector("#starMemberPosterContainer");
        // const targetDom = dom.firstChild;
        const config = {
          useCORS: true,
          logging: true,
          width: targetDom.offsetWidth,
          height: targetDom.offsetHeight - 4,
        };
        html2canvas(targetDom, config).then((canvas) => {
          this.starMemberPoster.isShow = true;
          this.starMemberPoster.posterUrl = canvas.toDataURL();
          this.starMemberPoster.isPoster = -1;
          Toast('长按保存图片');;
          // gio("track", "onShareBattleReport", { onSharePosters: "ShareLogo" });
        });
      }, 500);
    },
    lookBattleReportPoster() {
      Toast.loading({ message: "加载中...", forbidClick: true, duration: 0 });
      this.isShowBattleReportPosterPopUpDialog = true;
      this.battleReportPoster.isPoster = 1;
      // return;
      setTimeout(() => {
        const dom = document.querySelector("#battleReportPosterContainer");
        const targetDom = dom.firstChild;
        const config = {
          useCORS: true,
          logging: true,
          width: targetDom.offsetWidth,
          height: targetDom.offsetHeight - 4,
        };
        html2canvas(targetDom, config).then((canvas) => {
          this.battleReportPoster.isShow = true;
          this.battleReportPoster.posterUrl = canvas.toDataURL();
          this.battleReportPoster.isPoster = -1;
          Toast('长按保存图片');;
        });
      }, 500);
    },
    setUserInfo() {
      const userInfoId = JSON.parse(localStorage.getItem("userInfoId"));
      if (userInfoId) {
        this.currentCampusId = userInfoId.campusId;
        this.currentUserId = userInfoId.agentUserId;
      } else {
        Toast("找不到参赛信息");
      }
    },
    initTeamInfo() {
      let teamInfo = localStorage.getItem("historyTeamInfo");
      this.teamInfo = JSON.parse(teamInfo);
      document.title = this.teamInfo.cupName;
    },
    getAcquireDescribe(data) {
      let acquireDescribe = "";
      switch (data.type) {
        case 6: //6冠军战队
          acquireDescribe = this.teamInfo.cupName + data.war_zone + "冠军";
          break;
        case 7: // 7亚军战队
          acquireDescribe = this.teamInfo.cupName + data.war_zone + "亚军";
          break;
        case 8: // 8季军战队
          acquireDescribe = this.teamInfo.cupName + data.war_zone + "季军";
          break;
      }
      return acquireDescribe;
    },
    async eventHomePage() {
      let params = {
        param: {
          currentCampusId: this.currentCampusId,
          currentUserId: this.currentUserId,
          last_id: 0, //最后一个主建ID，分页用
          page_size: 100,
          scheduleId: this.scheduleId,
          seasonId: this.seasonId,
        },
      };
      let res = await eventHomePage(params);

      if (res.code == 0) {
        this.honorListLength = res.data.length;
        if (res.data.length > 3) {
          res.data.length = 3;
        }

        res.data.forEach((item) => {
          item = getHonorDesc(item, this.honorDescMap, this.teamInfo);
          item.day = formatDateStr(item.day);
        });

        this.honorList = res.data;
      } else {
        Toast(res.message);
      }
    },
    async teamRecord() {
      let params = {
        param: {
          currentCampusId: this.currentCampusId,
          currentUserId: this.currentUserId,
          padTeamId: "",
          scheduleId: this.scheduleId,
          seasonId: this.seasonId,
        },
      };
      let res = await teamRecord(params);
      if (res.code == 0) {
        this.teamRecordData = res.data;
        let gameType = localStorage.getItem("gameType");
        this.battleReportPosterData = {
          cupNumber: res.data.score,
          warZone: res.data.ware_zone,
          rank: res.data.rank,
          ware_zone_rank: res.data.ware_zone_rank,
          country_rank: res.data.country_rank,
          pkCount: res.data.pk_count,
          name: res.data.name,
          teamStatus: 3,
          group_name: res.data.group_name,
          date: res.data.yyyy_mm_dd,
          gameType: gameType,
        };
      } else {
        Toast(res.message);
      }
    },
  },
};
</script>

<style lang="less" scoped>
#app {
  height: auto;
  min-height: 100%;
}
.history-result-wrap {
  padding-bottom: 80px;
  width: 100%;
  &.winter_2024 {
    background: linear-gradient(180deg, #2BA8F6 0%, #3F85EF 100%);
  }
  &.autumn_2023 {
    background: linear-gradient(180deg, #6b3510 0%, #865d30 100%);
  }
  &.summer_2023 {
    background: linear-gradient(180deg, #0059c7 0%, #0098ff 100%);
    .result-module {
      footer {
        .more {
          color: #ffffff;
        }
      }
    }
  }
  // 春季赛
  &.spring_2023 {
    background: linear-gradient(180deg, #00236d 0%, #001d46 100%);
  }

  min-height: 100vh;
  .springBanner {
    height: 290px;
    img {
      width: 100%;
    }
  }

  .result-module {
    position: relative;
    section {
      margin-bottom: 40px;
      &:last-child {
        header {
          margin-bottom: 16px;
        }
        .list {
          .item {
            margin-bottom: 16px;
          }
        }
      }
    }
    .rank-data {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .data-num {
          font-size: 48px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #323232;
          margin: 0 0 8px 0;
          padding: 0;
        }
        .describe {
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #68707d;
          margin: 0 0 32px 0;
          padding: 0;
        }
      }
    }
    .main-module {
      margin-bottom: 40px;
    }
    .module-header {
      width: 550px;
      height: 72px;
      margin: 0 auto;
      // background: url('../../../src/assets/images/winterGame/line.png') no-repeat;
      background-size: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .header-title {
        font-size: 40px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }
    }
    .module-content {
      width: 622px;
      margin: 16px auto 0;
      background: #ffffff;
      border-radius: 8px;
      .current-game-info {
        padding-top: 48px;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #323232;
        text-align: center;
      }
      .view-all-games {
        padding: 58px;
        display: block;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #58abf6;
        text-align: right;
      }
      .acquire-time {
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #68707d;
        line-height: 40px;
        text-align: center;
      }
      .acquire-describe {
        height: 44px;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #444b65;
        line-height: 44px;
        text-align: center;
      }
    }
    footer {
      width: 622px;
      margin: 0 auto;
      margin-top: 24px;
      text-align: right;
      .more {
        width: 242px;
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #58abf6;
        line-height: 40px;
      }
    }
  }
}
</style>
